export default "__VITE_ASSET__CaXvq6Tk__"